import { OrderType, AppointmentType } from "ips/ac/model/odata/generated/IpsCoreModel";

export default class AppointmentTypeMapper {

  public static orderTypeToAppointmentType(sOrderType: string | null): AppointmentType | null {
    if (!sOrderType) {
      return null;
    }

    switch (sOrderType) {
      case OrderType.INTERNAL:
        return AppointmentType.OTHERS;

      case OrderType.SERVICE:
      case OrderType.QUOTATION:
      case OrderType.MEASUREMENT:
      case OrderType.OFFER:
      case OrderType.REMAINING:
      case OrderType.MAINTENANCE:
      case OrderType.COMPLAINT:
      case OrderType.PICKUP:
        return AppointmentType.SERVICE;

      case OrderType.DOCUMENTATION:
      default:
        return AppointmentType.INSTALLATION;
    }
  }
}
